import React from 'react';
import { Grid } from '@mui/material';
import {
    yes_no_options,
    bought_rented_options,
    asset_status_options,
    cylinder_status_options,
} from '../utils'
import {
    Input,
    DateInput,
    Select,
    WeightInput,
    ButtonNoBorder,
} from '../../Common';
import LocationDropdown from '../LocationDropdown';
import { isMobile } from '../../../utils';

const Form = ({
    index,
    cylinder: {
        newPurchaseAquisition,
        aquireLocation,
        location,
        subLocation,
        name,
        assetStatus,
        serialNumber,
        tagNumber,
        acquisitionDate,
        disbursementDate,
        regulatedAssets,
        materialType,
        materialStatus,
        cylinderStatus,
        currentGasWeightLBS,
        maxGasCapacity,
        dotExpirationDate,
        psiRating,
        currentPSI,
        boughtRented,
        locationOnSite,
        manufacturer,
        manufactureDate,
        modelNumber,
        modelYear,
        brand,
        poNumber,
        lifeTime,
        id,
        maxDate,
        viewMore,
    },
    isCalifornia,
    errors,
    handleCylinderFieldData,
    setAdditionalRequiredFields,
    selectOptions: {
        locations,
        acquireLocationOptions,
        materialTypes,
        materialStatuses,
        psiRatings,
        manufacturers,
        years,
        lifeTimeOptions,
    },
}) => (
    <>
        <Grid
            container
            columnSpacing={{ xs: 0, sm: 4 }}
            rowSpacing={{ xs: 3, sm: 4 }}
            alignItems="flex-start"
        >
            {!id && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Select
                        disabled={id}
                        value={newPurchaseAquisition}
                        label="Is this a new purchase / acquisition?"
                        options={yes_no_options}
                        onChange={e => {
                            setAdditionalRequiredFields(index, 'newPurchaseAquisition', e.target.value);
                        }}
                        error={errors.newPurchaseAquisition}
                    />
                </Grid>
            )}
            {newPurchaseAquisition === 1 && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Select
                        disabled={id}
                        value={aquireLocation}
                        label="Acquired From Location"
                        options={acquireLocationOptions}
                        onChange={e => handleCylinderFieldData(index, 'aquireLocation', e.target.value)}
                        error={errors.aquireLocation}
                    />
                </Grid>
            )}
            {!!id && (
                <Grid item xs={12} sm={12} md={6} lg={6}>
                    <Input
                        required
                        fullWidth
                        label="Name"
                        value={name}
                        onChange={e => handleCylinderFieldData(index, 'name', e.target.value)}
                        error={errors.name}
                    />
                </Grid>
            )}
            <LocationDropdown
                required
                disabled={id}
                locations={locations}
                location={location}
                subLocation={subLocation}
                onChangeLocation={e => handleCylinderFieldData(index, 'location', e)}
                onChangeSubLocation={e => handleCylinderFieldData(index, 'subLocation', e)}
                ErrorObject={errors.location}
            />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Select
                    required
                    value={assetStatus}
                    label="Asset Status"
                    options={asset_status_options}
                    onChange={e => handleCylinderFieldData(index, 'assetStatus', e.target.value)}
                    error={errors.assetStatus}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Input
                    required
                    fullWidth
                    label="Tag Number"
                    value={tagNumber}
                    onChange={e => handleCylinderFieldData(index, 'tagNumber', e.target.value, true)}
                    error={errors.tagNumber}
                    helperText={typeof errors.tagNumber === 'string' ? errors.tagNumber : null}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Input
                    required
                    fullWidth
                    label="Serial Number"
                    value={serialNumber}
                    onChange={e => handleCylinderFieldData(index, 'serialNumber', e.target.value, true)}
                    error={errors.serialNumber}
                    helperText={typeof errors.serialNumber === 'string' ? errors.serialNumber : null}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <DateInput
                    allowPast
                    date={acquisitionDate}
                    onChange={date => handleCylinderFieldData(index, 'acquisitionDate', date)}
                    label={`Acquisition Date ${id ? " " : "*"}`}
                    error={errors.acquisitionDate}
                    customHelperText={typeof errors.acquisitionDate === 'string' ? errors.acquisitionDate : undefined}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Select
                    required
                    value={materialType}
                    label="Material Type"
                    options={materialTypes}
                    onChange={e => handleCylinderFieldData(index, 'materialType', e.target.value, true)}
                    error={errors.materialType}
                    customHelperText={errors.materialType}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Select
                    required
                    value={materialStatus}
                    label="Material Status"
                    options={materialStatuses}
                    onChange={e => handleCylinderFieldData(index, 'materialStatus', e.target.value)}
                    error={errors.materialStatus}
                />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <Select
                    required
                    value={cylinderStatus}
                    label="Cylinder Status"
                    options={cylinder_status_options}
                    onChange={e => handleCylinderFieldData(index, 'cylinderStatus', e.target.value)}
                    error={errors.cylinderStatus}
                />
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6}>
                <WeightInput
                    required
                    removePadding
                    showConversionArrows
                    headerColor="#656565"
                    header="Current Gas Weight"
                    variant="standard"
                    customHelperText={errors.currentGasWeightLBS}
                    value={currentGasWeightLBS}
                    lbsError={errors.currentGasWeightLBS}
                    onChange={weight => handleCylinderFieldData(index, 'currentGasWeightLBS', weight)}
                    columnSpan={5}
                />
            </Grid>
            <Grid container item xs={12} sm={12} md={6} lg={6}>
                <WeightInput
                    required
                    removePadding
                    showConversionArrows
                    headerColor="#656565"
                    header="Max Gas Capacity"
                    variant="standard"
                    value={maxGasCapacity}
                    lbsError={errors.maxGasCapacity}
                    onChange={weight => handleCylinderFieldData(index, 'maxGasCapacity', weight)}
                    columnSpan={5}
                />
            </Grid>
            {viewMore && (
                <>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <DateInput
                            allowFuture
                            allowPast
                            required={cylinderStatus === 2 || cylinderStatus === 3}
                            date={disbursementDate}
                            onChange={date => handleCylinderFieldData(index, 'disbursementDate', date)}
                            label={(cylinderStatus === 2 || cylinderStatus === 3) ? 'Disbursement Date *' : 'Disbursement Date'}
                            error={errors.disbursementDate}
                            disabled={cylinderStatus !== 2 && cylinderStatus !== 3}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <DateInput
                            allowFuture
                            allowPast
                            date={dotExpirationDate}
                            onChange={date => handleCylinderFieldData(index, 'dotExpirationDate', date)}
                            label="DOT Expiration Date"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Select
                            value={psiRating}
                            label="PSI Rating"
                            options={psiRatings}
                            onChange={e => handleCylinderFieldData(index, 'psiRating', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Input
                            fullWidth
                            type="number"
                            label="Current PSI"
                            value={currentPSI}
                            onChange={e => handleCylinderFieldData(index, 'currentPSI', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Select
                            value={boughtRented}
                            label="Bought/Rented"
                            options={bought_rented_options}
                            onChange={e => handleCylinderFieldData(index, 'boughtRented', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Input
                            required={isCalifornia}
                            fullWidth
                            multiLine
                            label="Location On Site"
                            value={locationOnSite}
                            onChange={e => handleCylinderFieldData(index, 'locationOnSite', e.target.value)}
                            error={errors.locationOnSite}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Select
                            required={isCalifornia}
                            value={manufacturer}
                            label="Manufacturer"
                            options={manufacturers}
                            onChange={e => handleCylinderFieldData(index, 'manufacturer', e.target.value)}
                            error={errors.manufacturer}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <DateInput
                            allowPast
                            allowFuture
                            date={manufactureDate}
                            onChange={date => handleCylinderFieldData(index, 'manufactureDate', date)}
                            error={errors.manufactureDate}
                            label="Manufacturer Date"
                            maxDate={maxDate}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Input
                            required={isCalifornia}
                            fullWidth
                            label="Model Number"
                            value={modelNumber}
                            onChange={e => handleCylinderFieldData(index, 'modelNumber', e.target.value)}
                            error={errors.modelNumber}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Select
                            required={isCalifornia}
                            value={modelYear}
                            label="Model Year"
                            options={years}
                            onChange={e => handleCylinderFieldData(index, 'modelYear', e.target.value)}
                            error={errors.modelYear}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Input
                            fullWidth
                            label="Brand"
                            value={brand}
                            onChange={e => handleCylinderFieldData(index, 'brand', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Input
                            fullWidth
                            label="PO Number"
                            value={poNumber}
                            onChange={e => handleCylinderFieldData(index, 'poNumber', e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Select
                            value={lifeTime}
                            label="Expected Lifetime (years)"
                            options={lifeTimeOptions}
                            onChange={e => handleCylinderFieldData(index, 'lifeTime', e.target.value)}
                        />
                    </Grid>
                </>
            )}
            <Grid container item xs={12} sm={12} md={12} lg={12} justifyContent="center">
                <ButtonNoBorder
                    buttonText={viewMore ? 'Hide Extra Fields' : 'View More Fields'}
                    onClick={() => handleCylinderFieldData(index, 'viewMore', !viewMore)}
                    sx={{
                        minHeight: '42px',
                        minWidth: { xs: '100%', sm: 180 },
                        px: 2,
                    }}
                />
            </Grid>
        </Grid>
    </>
);

export default Form;
